<template>
  <div class="skill">

    <div class="row">
      <div class="col">
        <under-input v-model="item.name">
          Name
        </under-input>
      </div>
      <div class="col-3">
        <under-text class="text-center">
          <span slot="underline"><a>{{ skillBonus }}</a></span>
          Bonus
        </under-text>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <under-select v-model="item.attribute" :options="$rpgv.d20.attributeOptions()">
          Ability Score
        </under-select>
      </div>
      <div class="col-3">
        <under-text class="text-center">
          <span slot="underline">{{ $rpgv.d20.attributeBonus(attribute) }}</span>
          {{ item.attributeName }}
        </under-text>
      </div>
    </div>

    <div class="row text-center">
      <div class="col">
        <under-checkbox v-model="item.proficient">Prof</under-checkbox>
      </div>
      <div class="col">
        <under-checkbox v-model="item.expertise">Exp</under-checkbox>
      </div>
      <div class="col">
        <under-input v-model.number="item.misc" type="number" maxlength="2">Misc</under-input>
      </div>
      <div class="col" v-if="passiveList.includes(item.name)">
        <under-input v-model.number="item.passiveMisc" type="number" maxlength="2">Passive Misc</under-input>
      </div>
    </div>

  </div>
</template>
<script>
import UnderCheckbox from "../shared/_UnderCheckbox.vue";
import UnderInput from "../shared/_UnderInput.vue";
import UnderSelect from "../shared/_UnderSelect.vue";
import UnderText from "../shared/_UnderText.vue";

export default {
  name: "sheet-skills-fifth-edition",
  components: {
    UnderCheckbox,
    UnderInput,
    UnderSelect,
    UnderText
  },
  props: ["section", "item", "attribute", "skillBonus", "passiveList"]
};
</script>
